export { prepareIconsSprite } from "./icons-sprite";
export type { IconId } from "./icons-sprite";
export type { IconImage } from "./icons-sprite";
